<template>
  <div>
    <the-legend class="legend" v-show="isLegendVisible" />
    <div class="d-flex align-center">
      <base-rounded-button size="large" icon="mdi-layers" icon-size="36" @click="isLegendVisible = !isLegendVisible" />
    </div>
  </div>
</template>

<script>
import TheLegend from '@/components/map/TheLegend';
import BaseRoundedButton from '@/components/shared/buttons/BaseRoundedButton';

export default {
  name: 'LegendButtons',
  components: { TheLegend, BaseRoundedButton },
  data: () => ({
    isLegendVisible: false,
  }),
};
</script>

<style lang="scss" scoped>
.legend {
  max-width: 300px;
  max-height: 75vh;
  overflow-y: auto;
  transition-property: opacity transform;
  transition-duration: 0.5s;
}
</style>
